import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const fetchTreatmentOptions = async ({ token }) => {
  const authToken = token || localStorage.getItem("token");

  const res = await axios.get(`${__API_URL__}/api/appiell/treatments/options`, {
    headers: {
      Authorization: `Token ${authToken}`,
    },
  });

  return res.data;
};

const useGetTreatmentOptions = ({ token, enabled = true } = {}) => {
  return useQuery({
    queryKey: ["treatment_options"],
    queryFn: () => fetchTreatmentOptions({ token }),
    enabled,
    onError: (error) => {
      showApiErrorToast(error, "Failed to load treatment options");
    },
  });
};

export default useGetTreatmentOptions;
